import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FrDatePicker from '../components/FrDatePicker'
import FooterDelphus from '../components/FooterDelphus'
import RegLancamentos from './RegLancamentos'
import Dialog from '@material-ui/core/Dialog';


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import { dollar } from 'react-icons-kit/iconic/dollar';
import { colors } from '../utils/vars';

const swal = withReactContent(Swal)

function Lancamentos(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [pk_lan, setPk_lan] = useState()
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [selected, setSelected] = useState([])

  const [comboEstado, setComboEstado] = useState([{ value: '', display: '' }])
  const [comboPlc, setComboPlc] = useState([{ value: '', display: '' }])
  const [showLancamentos, setShowLancamentos] = useState(false)
  const [modalRegistro, setModalRegistro] = useState(false)
  const [comboTpc, setComboTpc] = useState([{ value: '', display: '' }])
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [comboSimNao, setComboSimNao] = useState([{ value: 'S', display: 'Sim' },{ value: 'N', display: 'Não' }])

  const columns = [
    { id: 'formatdata', numeric: false, label: 'Data', align: 'left', minWidth: 100, maxWidth: 150, },
    { id: 'descricao', numeric: false, label: 'Descrição', align: 'left', minWidth: 250 },
    { id: 'baixa_temporaria', numeric: false, label: 'Baixa Temporária', align: 'left', minWidth: 250 },
    { id: 'formatvalor', numeric: false, label: 'Valor', align: 'left', minWidth: 100, maxWidth: 120, },
    { id: 'saldo', numeric: false, label: 'Saldo', align: 'left', minWidth: 100, maxWidth: 120, },

  ]

  function buscaDados() {
    const urlParams = new URLSearchParams(window.location.search);
    let query = paramsToObject(urlParams)
    // setFilter(query)
    
    
   
    populateForm(document.getElementById('searchForm'), query)
    swal.close()
    if (query.buscar === 'true') {
      let event = new Event('build');
      getData(event)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      let d = (new Date())
      let auxValues = {...filter}
      d.setDate(d.getDate() - 15)
      auxValues.dataini = d.toISOString()
      setFilter(auxValues)

      setComboFpg(await api.getComboData('formas_pagamento'))
      setComboPlc(await api.getComboData('plano_contas'))
      setComboTpc(await api.getComboData('tipo_conta_plano'))
      setenableAdd(await api.getAcessos('Lancamentos', 'Inclusao'))
      setenableEdit(await api.getAcessos('Lancamentos', 'Alteracao'))
      setenableDel(await api.getAcessos('Lancamentos', 'Exclusao'))

      buscaDados()
     
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = {...filter}
    queryObject.buscar = true
    queryObject.ultimos_15 = true
    queryObject.fk_cta = props.fk_cta
    console.log(queryObject)
    setFiltered(true)
    if (!props.modal) {
      window.history.replaceState({ filtered: true }, 'filter', "/salute/lancamentos?" + objectToQueryString(queryObject));
    }
    swal.fire({
      html: <FrLoading text="Buscando dados..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/lancamentos?'+ objectToQueryString(queryObject)).then(r => {
      setData(r.data)
      swal.close()
    })
  }

  function clearForm(e) {
    e.preventDefault();
    if (!props.modal) {
      window.history.replaceState({ filtered: false }, 'filter', '/salute/lancamentos');
      document.getElementById('searchForm').reset()
    }
    setFilter({})
  }

  function chamaRegistro(e) {
    e.preventDefault();
    if (!props.modal)
      window.location.href = "/salute/lancamentos/registro"
    else{
      setPk_lan(null)
      setModalRegistro(true)
    }
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  const fechaModal = (e) => {
    setModalRegistro(false)
  }

  const confirmaBaixa = (e) => {
    e.preventDefault();
    if (selected.length == 0) {
      return swal.fire('Nenhum registro selecionado!', 'Selecione ao menos 1 registro', 'error')
    }
    console.log(selected)
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Confirma baixa dos registros selecionados?<p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: colors.success500,
      cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        swal.fire({
          html: <FrLoading text="Carregando..." />,
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        api.post('lancamentos/confirma_baixa', {pks: selected}).then(r => {
          if (r.status == 200) {
            swal.fire('Baixas Confirmadas!', 'Operação concluída', 'success')
          } else {
            swal.fire('Erro nas baixas', 'Não foi possível concluir operação.', 'error')
          }
        })
      }
    })
  }

  return (
    <div className={props.modal ? "ManutModal" : "Manut"}>
      {!props.modal ? <NavBar /> : <></>}
      <div className={props.modal ? "ManutContentModal" : "ManutContent"}>
        <div className="defaultHeader">
          <h3>Lançamentos</h3>
          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />
        <div className="filtersDiv" style={{paddingInline: 8}}>
          <form id="searchForm" onSubmit={getData}>
            <div>
            <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.fk_tpc || ''}
                style={{ width: 170 }}
                name="fk_tpc"
                id="fk_tpc"
                label='Tipo Plano Conta'
                data={[{display: "Receita", value: 1}, {display: 'Despesa', value: 2}]}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.fk_plc || ''}
                style={{ width: 170 }}
                name="fk_plc"
                id="fk_plc"
                label='Plano de Contas'
                data={comboPlc}
                onChange={handleChange}
              />

              <FrTextInput
                maxLength='100'
                value={filter.descricao || ''}
                onChange={handleChange}
                name="descricao"
                id="descricao"
                color="#389492"
                label={"Descrição"}
                variant="outlined"
                size="small"
                style={{ width: 420 }}
              />

              <FrSelect
                value={filter.fk_fpg || ''}
                style={{ width: 170 }}
                name="fk_fpg"
                id="fk_fpg"
                label='Forma pagamento'
                data={comboFpg}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.compensado || ''}
                style={{ width: 170 }}
                name="compensado"
                id="compensado"
                label='Compensado'
                data={comboSimNao}
                onChange={handleChange}
              />
              <FrSelect
                value={filter.baixa_temporaria || ''}
                style={{ width: 170 }}
                name="baixa_temporaria"
                id="baixa_temporaria"
                label='Baixa Temporaria'
                data={comboSimNao}
                onChange={handleChange}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              <button onClick={chamaRegistro}>
                <Icon icon={ic_add_box} size={18} />
                Novo Registro
              </button>
              <button onClick={confirmaBaixa}>
                <Icon icon={dollar} size={18} />
                Confirmar Baixa
              </button>
              
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv" style={{paddingInline: 8}}>
          <FrTable 
            regName="lancamentos" 
            columns={columns} 
            searched={filtered} 
            setShowModal={setModalRegistro} 
            setPk_lan={setPk_lan}
            modal
            mostraCheck='S'
            selected={selected}
            setSelected={setSelected}
            codeName="pk_lan" 
            page={'Lancamentos'} 
            data={data} 
            enableEdit={enableEdit} 
            enableDel={enableDel} 
          />
        </div>
        <FooterDelphus />
        <div className="FrModalFooter">
            <div className="FrModalButtonsDiv">

              <button onClick={() => {props.setShowModalLancamentos(false)}}> Fechar </button>
            </div>
          </div>
      </div>
      <div>
        <Dialog aria-labelledby="simple-dialog-title" open={modalRegistro} fullWidth={true} maxWidth={'lg'}>
          
          <RegLancamentos 
            modal 
            setPk_lan={setPk_lan} 
            pk_lan={pk_lan} 
            setShowModal={setModalRegistro} 
            buscaDados={buscaDados}
            fk_cta={props.fk_cta}
          />
          
        </Dialog>
      </div>
    </div>
  );
}

export default Lancamentos;
